module.exports = __webpack_public_path__ + "img/ios1icon3.a82b7a17.png";